import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default function useQrCodeView() {
  const store = useStore();
  const course = ref();

  const error = computed(() => store.getters["utilities/getErrors"]);
  const loading = computed(() => store.getters["utilities/isLoading"]);
  const generatingQrCode = computed(
    () => store.getters["utilities/isGeneratingQrCode"]
  );
  const qrCodeUrl = computed(() => store.getters["utilities/getQrCodeUrl"]);

  const success = computed(() => store.getters["utilities/getSuccessStatus"]);

  watch(error, (newError) => {
    if (newError) {
      store.dispatch("toastNotification/displayToast", {
        message: newError,
        type: "error",
      });
    }
  });

  watch(success, (newStatus) => {
    if (newStatus) {
      store.dispatch("toastNotification/displayToast", {
        message: "Course configuration updated successfully.",
        type: "success",
      });
    }
  });

  const isFormValid = computed(() => {
    return course.value?.id;
  });

  const hasQrCodeUrl = computed(() => {
    return store.getters["utilities/getQrCodeUrl"] !== null;
  });

  const generateQrCode = () => {
    const payload = extractCourseInformation(course.value.url);
    store.dispatch("utilities/generateQrCode", payload);
  };

  const downloadQrCode = async () => {
    const response = await fetch(qrCodeUrl.value);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `${course.value.name.toLowerCase()}_qr_code`;
    link.click();

    URL.revokeObjectURL(blobUrl);
  };

  const clearQrCodeUrl = () => {
    store.dispatch("utilities/clearQrCodeUrl");
  };

  const extractCourseInformation = (url) => {
    const { hostname, pathname } = new URL(url);
    const dropletName = hostname.split(".")[0] ?? "";
    const courseName = pathname.split("/").filter(Boolean)[0] ?? "";

    return {
      dropletName,
      courseName,
    };
  };

  return {
    course,
    loading,
    generatingQrCode,
    isFormValid,
    downloadQrCode,
    generateQrCode,
    hasQrCodeUrl,
    qrCodeUrl,
    clearQrCodeUrl,
  };
}
